import React, { useEffect } from 'react'
import styled from 'styled-components'
import { Layout } from 'antd'
import { RightOutlined } from '@ant-design/icons'
import { useHistory } from 'react-router-dom'
import { Helmet } from 'react-helmet'
import Iframe from '../QuickUpdate/components/Iframe.components'
import { REACT_APP_URL } from '../../config/env'

const Container = styled.div``

const CreateProjectMain = () => {
  const history = useHistory()

  useEffect(() => {
    const getExpectedOrigin = () => {
      try {
        return new URL(REACT_APP_URL).origin
      } catch {
        return String(REACT_APP_URL || '').replace(/\/$/, '')
      }
    }

    const openUrlFromExternal = (event) => {
      if (event.origin !== getExpectedOrigin()) return
      if (event.data.action === 'openHelpdeskInApp') {
        window.open(`${REACT_APP_URL}/helpdesk`, '_self')
      }
      if (
        event.data.action === 'closeCreateProject' ||
        event.data.action === 'closeProjectForm'
      ) {
        const tab = event.data.returnTo === 'gantt' ? '1' : '2'
        localStorage.setItem('activeProjectTab', tab)
        history.push('/project-list')
      }
    }
    window.addEventListener('message', openUrlFromExternal)
    return () => window.removeEventListener('message', openUrlFromExternal)
  }, [history])

  const goProjectList = () => {
    localStorage.setItem('activeProjectTab', '2')
    history.push('/project-list')
  }

  return (
    <Container className="main-container">
      <Helmet>
        <title>AXONS PROJECT | Create Project</title>
      </Helmet>
      <div className="BreadCrumb ">
        <h4 className="level1" onClick={() => goProjectList()}>
          Project
        </h4>
        <RightOutlined className="icon-style" style={{ marginTop: -6 }} />
        <h4
          className="level2 cutter-text-line-1 "
          style={{ minHeight: 28, maxWidth: '60%' }}
        >
          Create Project
        </h4>
      </div>
      <Layout className="layout-overview">
        <Iframe source={`${REACT_APP_URL}/v2/project-create?from=project-card`} />
      </Layout>
    </Container>
  )
}

export default CreateProjectMain
